/* ============================================================================
   JuiceBox Limited VIP 2026 — Sorten-Finder on the Tresor password page (merchant 2026-10-04, v2 2026-10-09)

   Markup + data: snippets/jb-vip-finder.liquid (rendered by sections/jb-vip-sorten). Optional by design:
     · ONLY on the launch day — 10.10. 00:00–24:00 Vienna, from the theme setting jb_vip_launch_iso. Before and after it
       nothing of the finder shows (entry row, popup, pill). A tab left open overnight switches it on at midnight.
     · popup — a big centred card after the "erscheint nach" delay (theme setting jb_vip_finder_delay), only before
       10:00: what happens today (countdown to 10:00, the three steps), "Sorten-Finder starten" / "Nein danke". May cover
       the keypad (merchant 2026-10-09) — it never shows while the keypad is being typed into or on a wrong-code render.
       × / "Nein danke" is remembered for the day. It never opens in the last minute, and closes itself at 09:59.
     · finder — a <dialog>: 3 questions → the matching flavours one card at a time (♥ Merken / ✕ Weiter, swipe or tap,
       ←/→) → Merkliste with quantities → "Sollen wir deine Sorten vorbereiten …?" Ja / Nein. In the last minute before
       10:00 and after it, a gold bar in the finder counts down / says the safe is open, with "Quiz beenden".
     · pill — for customers who said Ja: "Auswahl gespeichert: N Boxen · Ändern" (bottom), × hides it for the visit.
   Deck: from 10:00, sold-out flavours (baked `avail` at render time) are left out — before 10:00, or when the bake says
   all 28 are sold out (stock not loaded / not readable on the locked shop), every flavour counts; the taste answers FILTER; whenever fewer than
   10 remain, random other flavours fill up to 10 (same line first, then the other line).
   Storage: NOTHING is kept without the customer's Ja (merchant 2026-10-09). Progress lives in sessionStorage
   (jbVipFinder:v2 — this tab, survives a reload or a wrong code, gone with the tab); the first version's
   localStorage jbVipFinder:v1 is removed on sight. Ja → localStorage jbVipPicks:v1, read by the Limited page selector
   (snippets/jb-multi-flavour-selector-limited-vip-2026, applySavedPicks). Nein → Merkliste and progress are deleted.
   Picks are VARIANT IDS (strings) — never names: two flavours are called "Johannisbeere".
   The keypad: keys typed inside the finder or popup never reach the safe — both dialogs stop keydown propagation, and
   the gate in assets/jb-vip.js ignores events from [data-jb-vip-finder]. No network calls, no cart writes here.
   Preview on another day: append #vipf-now=2026-10-10T09:59:20%2B02:00 — moves only the finder's clock (this tab).
   ========================================================================== */
(function () {
  'use strict';

  if (window.__jbVipFinder) return;
  window.__jbVipFinder = true;

  var STATE_KEY = 'jbVipFinder:v2';    // sessionStorage
  var OLD_STATE_KEY = 'jbVipFinder:v1'; // localStorage of v1 (autosaved without asking) — removed
  var PICKS_KEY = 'jbVipPicks:v1';
  var POP_KEY = 'jbVipFinderPop'; // × / "Nein danke" on the popup — counts only on the launch day itself
  var NOW_KEY = 'jbVipFinderNow';
  var LAUNCH = '2026-10';
  var QTY_MAX = 10;
  var MIN_DECK = 10;
  var FINAL_MS = 60 * 1000;
  var DAY_MS = 24 * 3600 * 1000;
  var SWIPE_AT = 90; // px

  var ICON = {
    heart: '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M12 21s-7.5-4.6-9.6-9.2C.9 8.5 3 5 6.4 5c2 0 3.3 1 4.1 2.2h3c.8-1.2 2.1-2.2 4.1-2.2C21 5 23.1 8.5 21.6 11.8 19.5 16.4 12 21 12 21z"/></svg>',
    cross: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    close: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    check: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    check18: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    arrow: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    lock: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
    minus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/></svg>',
    plus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>',
    trash: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // web storage that may be missing (private mode, blocked site data) — every access guarded
  function guard(name) {
    try { var s = window[name], k = '__jbvipf'; s.setItem(k, '1'); s.removeItem(k); return s; } catch (e) { return null; }
  }
  var store = guard('localStorage'), sess = guard('sessionStorage');
  function load(key, s) { s = s || store; if (!s) return null; try { return JSON.parse(s.getItem(key) || 'null'); } catch (e) { return null; } }
  function save(key, val, s) { s = s || store; if (!s) return false; try { s.setItem(key, JSON.stringify(val)); return true; } catch (e) { return false; } }
  function drop(key, s) { s = s || store; if (!s) return; try { s.removeItem(key); } catch (e) { /* ignore */ } }
  function clampQty(n) { n = parseInt(n, 10); if (!(n > 0)) return 1; return Math.min(QTY_MAX, n); }

  // the finder's clock — real time, unless a preview hash moved it (this tab only)
  var skew = 0;
  (function () {
    var m = /(?:^|[#&])vipf-now=([^&]+)/.exec(window.location.hash || '');
    var t = m ? Date.parse(decodeURIComponent(m[1])) : NaN;
    if (isFinite(t)) { skew = t - Date.now(); save(NOW_KEY, skew, sess); return; }
    var k = load(NOW_KEY, sess);
    if (typeof k === 'number' && isFinite(k)) skew = k;
  })();
  function now() { return Date.now() + skew; }

  // midnight (Vienna) of the day that contains ms
  function viennaMidnight(ms) {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Vienna', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
      var h = parseInt(p.hour, 10) % 24, m = parseInt(p.minute, 10), s = parseInt(p.second, 10);
      if (isFinite(h) && isFinite(m) && isFinite(s)) return ms - ((h * 60 + m) * 60 + s) * 1000 - (ms % 1000);
    } catch (e) { /* old browser without time zones */ }
    return ms - 10 * 3600 * 1000; // the launch is 10:00 Vienna
  }

  function init() {
    var dataEl = document.getElementById('jb-vipf-data');
    var dlg = document.getElementById('jb-vipf');
    if (!dataEl || !dlg || typeof dlg.showModal !== 'function') return;

    var cfg, info = {};
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    try { info = JSON.parse((document.getElementById('jb-vipf-info') || {}).textContent || '{}') || {}; } catch (e) { info = {}; }

    // only on the launch day
    var launchMs = Number(cfg.launch) > 0 ? Number(cfg.launch) * 1000 : 0;
    if (!launchMs) return;
    var dayStart = viennaMidnight(launchMs), dayEnd = dayStart + DAY_MS;
    // cfg.start (merchant 2026-10-09 evening): switched on already on the eve — never later than the launch day's midnight
    var activeFrom = Number(cfg.start) > 0 ? Math.min(Number(cfg.start) * 1000, dayStart) : dayStart;
    // 'off' (outside activeFrom … end of the launch day) · 'wait' (before the last minute) · 'final' (last minute) · 'open' (from 10:00)
    function phase() {
      var t = now();
      if (t < activeFrom || t >= dayEnd) return 'off';
      if (t >= launchMs) return 'open';
      return t >= launchMs - FINAL_MS ? 'final' : 'wait';
    }

    // the flavours, joined with the info map by VARIANT ID
    var flavours = [], byId = {};
    (cfg.flavours || []).forEach(function (f) {
      if (!f || !/^\d{6,}$/.test(String(f.id)) || (f.line !== 'light' && f.line !== 'original') || byId[String(f.id)]) return;
      f.id = String(f.id);
      f.cats = Array.isArray(f.cats) ? f.cats.filter(Boolean) : [];
      f.avail = f.avail !== false;
      var x = info[f.id] || null;
      f.info = x;
      f.e = x && Number(x.e) > 0 ? Number(x.e) : 0;
      f.fan = !!(x && x.fan === true);
      flavours.push(f);
      byId[f.id] = f;
    });
    if (!flavours.length) return;
    var CATS = (cfg.cats || []).filter(function (c) { return c && c.k; });

    var pop = document.getElementById('jb-vipf-pop');
    var popBox = pop && pop.querySelector('[data-vipf-pop-body]');
    if (pop && (typeof pop.showModal !== 'function' || !popBox)) pop = null;
    var body = dlg.querySelector('[data-vipf-body]');
    var footer = dlg.querySelector('[data-vipf-footer]');
    var clock = dlg.querySelector('[data-vipf-clock]');
    // a view's buttons go into the fixed footer: only the content above scrolls, the buttons stay in view
    function F(html) { return '<div data-vipf-foot hidden>' + html + '</div>'; }
    // out of the section (overflow: hidden there) — top layer / fixed position need no ancestors
    document.body.appendChild(dlg);
    if (pop) document.body.appendChild(pop);

    /* ---------- state (this tab only until the customer says Ja) ---------- */
    drop(OLD_STATE_KEY);
    function fresh() { return { v: 2, step: 'line', line: null, cats: [], pref: null, order: [], pos: 0, hist: [], likes: {}, likeOrder: [] }; }
    var st = load(STATE_KEY, sess);
    if (!st || typeof st !== 'object' || st.v !== 2) st = fresh();
    // sanitise whatever came back from storage
    st.cats = Array.isArray(st.cats) ? st.cats.filter(function (k) { return CATS.some(function (c) { return c.k === k; }); }) : [];
    st.order = Array.isArray(st.order) ? st.order.filter(function (id) { return byId[id]; }) : [];
    st.hist = Array.isArray(st.hist) ? st.hist.filter(function (h) { return h && byId[h.id]; }) : [];
    st.likes = st.likes && typeof st.likes === 'object' ? st.likes : {};
    Object.keys(st.likes).forEach(function (id) { if (!byId[id]) delete st.likes[id]; else st.likes[id] = clampQty(st.likes[id]); });
    st.likeOrder = Array.isArray(st.likeOrder) ? st.likeOrder.filter(function (id, i, a) { return st.likes[id] && a.indexOf(id) === i; }) : [];
    Object.keys(st.likes).forEach(function (id) { if (st.likeOrder.indexOf(id) < 0) st.likeOrder.push(id); });
    st.pos = Math.max(0, Math.min(parseInt(st.pos, 10) || 0, st.order.length));
    if (['line', 'taste', 'pref', 'deck', 'list', 'saved'].indexOf(st.step) < 0) st.step = 'line';
    if (st.step === 'deck' && !st.order.length) st.step = 'line';
    if (st.step === 'saved' && !readPicks()) st.step = 'list';
    var declined = null; // the Merkliste right after "Nein" — in memory only, for the "Doch vorbereiten" undo
    var leaving = false; // "Quiz beenden" from the countdown bar: Ja / Nein then go straight to the keypad

    function persist() {
      st.ts = Date.now();
      save(STATE_KEY, st, sess);
      // after the Ja, the saved selection follows every later change (Merkliste, more likes, undo) — nobody has to
      // say Ja again; an empty Merkliste removes it
      if (readPicks()) {
        if (!writePicks()) drop(PICKS_KEY);
        refreshEntry();
      }
    }
    function wipe() { st = fresh(); drop(STATE_KEY, sess); }

    function readPicks() {
      var p = load(PICKS_KEY);
      if (!p || p.v !== 1 || p.launch !== LAUNCH || !Array.isArray(p.items) || !p.items.length) return null;
      return p;
    }
    function picksCount(p) { return (p && p.items || []).reduce(function (n, i) { return n + clampQty(i.qty); }, 0); }
    function writePicks() {
      var items = st.likeOrder.filter(function (id) { return byId[id] && st.likes[id] > 0; }).map(function (id) {
        return { id: id, qty: clampQty(st.likes[id]), name: byId[id].name, line: byId[id].line };
      });
      if (!items.length) return false;
      return save(PICKS_KEY, { v: 1, launch: LAUNCH, savedAt: Date.now(), items: items });
    }

    /* ---------- helpers ---------- */
    // sold out counts only from 10:00 — before that nothing can be, and stock 0 just means it is not loaded yet;
    // and never when the bake says "all sold out" (an empty quiz helps nobody)
    function stockCounts() { return phase() === 'open' && flavours.some(function (f) { return f.avail; }); }
    function isAvail(f) { return f.avail || !stockCounts(); }
    function poolFor(line) { return flavours.filter(function (f) { return isAvail(f) && (!line || line === 'both' || f.line === line); }); }
    function lineLabel(l) { return l === 'light' ? 'Light' : 'Original'; }
    function likedCount() { return st.likeOrder.reduce(function (n, id) { return n + (st.likes[id] ? 1 : 0); }, 0); }
    function boxes() { return st.likeOrder.reduce(function (n, id) { return n + (st.likes[id] || 0); }, 0); }
    function unsaved() { return likedCount() > 0 && !readPicks(); }
    // 1 Los per box, no cap since 07.10. (Teilnahmebedingungen version 4) — as in the cart bar
    function loseText(n) { return n === 1 ? '1 Los' : n + ' Lose'; }
    function shuffle(a) {
      for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; }
      return a;
    }
    function matches(f) { return !st.cats.length || st.cats.some(function (k) { return f.cats.indexOf(k) >= 0; }); }

    // quiz → deck: available flavours of the chosen line that fit the chosen Geschmack, scored (+2 per Geschmack,
    // +2 when it fits "Lieblinge / Neues", +0.5 Fan-Liebling, then the merchant's grid order = stock ranking).
    // Fewer than MIN_DECK → random other available flavours fill up: same line first, then the other line.
    function buildOrder() {
      var line = poolFor(st.line);
      var ids = line.filter(matches).map(function (f) {
        var s = 0;
        st.cats.forEach(function (k) { if (f.cats.indexOf(k) >= 0) s += 2; });
        if (st.pref === 'fav' && (f.fan || f.e >= 5)) s += 2;
        if (st.pref === 'new' && (f.neu || f.community || (f.e > 0 && f.e <= 2))) s += 2;
        if (f.fan) s += 0.5;
        return { id: f.id, s: s, o: Number(f.order) || 0 };
      }).sort(function (a, b) { return b.s - a.s || a.o - b.o; }).map(function (x) { return x.id; });
      if (ids.length < MIN_DECK) {
        var seen = {};
        ids.forEach(function (id) { seen[id] = true; });
        var rest = function (list) { return shuffle(list.filter(function (f) { return !seen[f.id]; }).map(function (f) { return f.id; })); };
        var sameLine = rest(line);
        sameLine.forEach(function (id) { seen[id] = true; });
        ids = ids.concat(sameLine, rest(poolFor('both'))).slice(0, Math.max(MIN_DECK, ids.length));
      }
      return ids;
    }
    // available flavours the deck has not shown yet ("Weitere Sorten ansehen")
    function moreIds() {
      var inDeck = {};
      st.order.forEach(function (id) { inDeck[id] = true; });
      return poolFor('both').filter(function (f) { return !inDeck[f.id]; })
        .sort(function (a, b) { return (a.line === st.line ? 0 : 1) - (b.line === st.line ? 0 : 1) || (Number(a.order) || 0) - (Number(b.order) || 0); })
        .map(function (f) { return f.id; });
    }

    function gateEl() { return document.querySelector('[data-jb-vip-gate]'); }
    function gateLive() { var g = gateEl(); return !!(g && g.offsetParent !== null); }
    function gateBusy() {
      var g = gateEl();
      if (!g) return false;
      var input = g.querySelector('[data-jb-vip-code]');
      return g.classList.contains('is-error') || g.classList.contains('is-typing') || !!(input && input.value) ||
        (document.activeElement && g.contains(document.activeElement));
    }
    // the keypad once it is live; before 10:00 the dimmed safe / the countdown it replaces
    function gateTarget() {
      if (gateLive()) return gateEl();
      var c = document.querySelectorAll('.jb-vip-gate--locked, .jb-vip-countdown');
      for (var i = 0; i < c.length; i++) if (c[i].offsetParent !== null) return c[i];
      return null;
    }
    function toGate() {
      close();
      closePop(false);
      var g = gateTarget();
      if (!g) { try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); } return; }
      try { g.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { g.scrollIntoView(); }
      var input = gateLive() && g.querySelector('[data-jb-vip-code]');
      if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 350);
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function untilLaunch(short) {
      var s = Math.max(0, Math.ceil((launchMs - now()) / 1000));
      if (short) return Math.floor(s / 60) + ':' + pad(s % 60);
      return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    }

    /* ---------- views ---------- */
    function render() {
      var html = '';
      if (st.step === 'line') html = viewLine();
      else if (st.step === 'taste') html = viewTaste();
      else if (st.step === 'pref') html = viewPref();
      else if (st.step === 'deck') html = st.pos >= st.order.length ? (st.step = 'list', viewList()) : viewDeck();
      else if (st.step === 'list') html = viewList();
      else if (st.step === 'declined') html = viewDeclined();
      else html = viewSaved();
      body.innerHTML = html;
      body.scrollTop = 0;
      var src = body.querySelector('[data-vipf-foot]');
      if (footer) {
        if (src) { footer.innerHTML = src.innerHTML; footer.hidden = false; } else { footer.innerHTML = ''; footer.hidden = true; }
      }
      if (src && footer) src.parentNode.removeChild(src);
      else if (src) src.hidden = false; // no footer in the markup (stale cache): keep the buttons where they are
      if (st.step === 'deck') {
        bindSwipe();
        // the next card's picture is already loaded when the customer swipes
        var next = byId[st.order[st.pos + 1]];
        if (next && next.img) { var pre = new Image(); pre.src = next.img; }
      }
      updateClock();
      if (st.step !== 'declined') persist();
    }

    function viewLine() {
      var nL = poolFor('light').length, nO = poolFor('original').length;
      return '<p class="jb-vipf__step">Frage 1 von 3</p>' +
        '<h2 class="jb-vipf__h" id="jb-vipf-title">Light oder Original?</h2>' +
        '<p class="jb-vipf__sub">Wir zeigen dir danach die Sorten, die am besten zu dir passen.</p>' +
        '<div class="jb-vipf__opts">' +
          opt('line', 'light', 'Light', nL + ' Sorten', st.line === 'light') +
          opt('line', 'original', 'Original', nO + ' Sorten', st.line === 'original') +
          opt('line', 'both', 'Beides', 'Alle ' + (nL + nO) + ' Sorten', st.line === 'both') +
        '</div>' +
        '<div class="jb-vipf__row"><span></span><button type="button" class="jb-vipf__link" data-vipf-skip="line">Überspringen</button></div>';
    }
    function opt(kind, val, label, small, on) {
      return '<button type="button" class="jb-vipf__opt" data-vipf-' + kind + '="' + val + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
        '<span>' + esc(label) + (small ? '<small>' + esc(small) + '</small>' : '') + '</span>' +
        '<span class="jb-vipf__opt-arrow">' + ICON.arrow + '</span></button>';
    }
    function viewTaste() {
      var pool = poolFor(st.line);
      var chips = CATS.map(function (c) {
        var n = pool.filter(function (f) { return f.cats.indexOf(c.k) >= 0; }).length;
        if (!n) return '';
        var on = st.cats.indexOf(c.k) >= 0;
        return '<li><button type="button" class="jb-vipf__chip" data-vipf-cat="' + esc(c.k) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
          esc(c.l) + ' <small>' + n + '</small></button></li>';
      }).join('');
      return '<p class="jb-vipf__step">Frage 2 von 3</p>' +
        '<h2 class="jb-vipf__h" id="jb-vipf-title">Worauf hast du Lust?</h2>' +
        '<p class="jb-vipf__sub">Wähle so viele, wie du magst – oder überspring die Frage.</p>' +
        '<ul class="jb-vipf__chips">' + chips + '</ul>' +
        F('<button type="button" class="jb-vipf__primary jb-vipf__primary--wide" data-vipf-next="taste">Weiter ' + ICON.arrow + '</button>' +
          '<div class="jb-vipf__row"><button type="button" class="jb-vipf__link" data-vipf-back="line">Zurück</button>' +
          '<button type="button" class="jb-vipf__link" data-vipf-skip="taste">Überspringen</button></div>');
    }
    function viewPref() {
      return '<p class="jb-vipf__step">Frage 3 von 3</p>' +
        '<h2 class="jb-vipf__h" id="jb-vipf-title">Bewährt oder neu?</h2>' +
        '<p class="jb-vipf__sub">Danach geht’s direkt zu deinen Sorten.</p>' +
        '<div class="jb-vipf__opts">' +
          opt('pref', 'fav', 'Bewährte Lieblinge', 'Die Sorten, die schon oft dabei waren', st.pref === 'fav') +
          opt('pref', 'new', 'Neues entdecken', 'Premieren und Community-Sorten', st.pref === 'new') +
          opt('pref', 'any', 'Ich bin offen für alles', '', st.pref === 'any') +
        '</div>' +
        '<div class="jb-vipf__row"><button type="button" class="jb-vipf__link" data-vipf-back="taste">Zurück</button>' +
        '<button type="button" class="jb-vipf__link" data-vipf-skip="pref">Überspringen</button></div>';
    }
    // the info map as small buttons below the description (merchant 2026-10-09: the picture comes first)
    function infoItems(x) {
      if (!x) return [];
      var out = [], h = x.h || '';
      if (x.b) out.push({ l: h && h !== 'Kundenstimme' && h !== 'Ausverkauft-Bilanz' ? h : 'Die Geschichte', html: '<p>' + esc(x.b) + '</p>' });
      if (x.n) out.push({ l: 'Ausverkauft-Bilanz', html: '<p class="jb-vipf__stat"><b>' + esc(x.n) + '</b><span>' + esc(x.nt || '') + '</span></p>' });
      if (x.q) out.push({ l: 'Kundenstimme', html: '<p class="jb-vipf__quote">„' + esc(x.q) + '“' + (x.a ? ' <span class="jb-vipf__attr">— ' + esc(x.a) + '</span>' : '') + '</p>' });
      if (x.f) out.push({ l: 'Gut zu wissen', html: '<p class="jb-vipf__fact">' + esc(x.f) + '</p>' });
      return out;
    }
    function viewDeck() {
      var f = byId[st.order[st.pos]];
      var total = st.order.length;
      var meta = f.e === 1 ? 'Premiere – zum 1. Mal dabei' : (f.e > 1 ? 'Zum ' + f.e + '. Mal dabei' : '');
      var badges = '<span class="jb-vipf__badge jb-vipf__badge--line">' + lineLabel(f.line) + '</span>' +
        (f.neu ? '<span class="jb-vipf__badge jb-vipf__badge--gold">Neu</span>' : '') +
        (f.fan ? '<span class="jb-vipf__badge jb-vipf__badge--gold">Fan-Liebling</span>' : '') +
        (f.community ? '<span class="jb-vipf__badge">Community Sorte</span>' : '');
      var liked = !!st.likes[f.id];
      var items = infoItems(f.info);
      // the first info is the description; without one, the first info item takes its place
      var first = f.desc ? '<p class="jb-vipf__desc">' + esc(f.desc) + '</p>' : (items.length ? '<div class="jb-vipf__desc">' + items.shift().html + '</div>' : '');
      var more = items.length
        ? '<div class="jb-vipf__tabs" role="group" aria-label="Mehr über ' + esc(f.name) + '">' + items.map(function (it, i) {
            return '<button type="button" class="jb-vipf__tab" data-vipf-tab="' + i + '" aria-expanded="false">' + esc(it.l) + '</button>';
          }).join('') + '</div>' +
          items.map(function (it, i) { return '<div class="jb-vipf__info" data-vipf-panel="' + i + '" hidden>' + it.html + '</div>'; }).join('')
        : '';
      return '<p class="jb-vipf__progress"><span>Sorte <b>' + (st.pos + 1) + '</b> von ' + total + '</span><span><b>' + likedCount() + '</b> gemerkt</span></p>' +
        '<div class="jb-vipf__bar" aria-hidden="true"><i style="width:' + Math.round((st.pos / total) * 100) + '%"></i></div>' +
        '<h2 class="jb-vipf__h" id="jb-vipf-title" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">' + esc(f.name) + '</h2>' +
        '<article class="jb-vipf__card" data-vipf-card>' +
          '<div class="jb-vipf__media">' + (f.img ? '<img class="jb-vipf__media-bg" src="' + esc(f.img) + '" alt="" aria-hidden="true" decoding="async">' +
            '<img class="jb-vipf__media-img" src="' + esc(f.img) + '" alt="" width="480" height="480" decoding="async">' : '') +
            '<span class="jb-vipf__stamp jb-vipf__stamp--like" data-vipf-stamp="like">Merken</span>' +
            '<span class="jb-vipf__stamp jb-vipf__stamp--pass" data-vipf-stamp="pass">Weiter</span>' +
            '<div class="jb-vipf__badges">' + badges + '</div>' +
            // phones: name + line/meta sit IN the picture (snippets/jb-vip-finder.liquid hides them below there)
            '<div class="jb-vipf__ovl" aria-hidden="true"><p class="jb-vipf__ovl-name">' + esc(f.name) + '</p>' +
              '<p class="jb-vipf__ovl-meta">' + lineLabel(f.line) + (meta ? ' · ' + esc(meta) : '') + '</p></div>' +
          '</div>' +
          '<div class="jb-vipf__cbody">' +
            '<p class="jb-vipf__name">' + esc(f.name) + '</p>' +
            (meta ? '<p class="jb-vipf__meta">' + esc(meta) + '</p>' : '') +
            first + more +
          '</div>' +
        '</article>' +
        F('<div class="jb-vipf__actions">' +
            '<button type="button" class="jb-vipf__pass" data-vipf-pass>' + ICON.cross + ' Weiter</button>' +
            '<button type="button" class="jb-vipf__like" data-vipf-like>' + ICON.heart + (liked ? ' Gemerkt' : ' Merken') + '</button>' +
          '</div>' +
          '<p class="jb-vipf__hint">Wischen geht auch: nach rechts merken, nach links weiter.</p>' +
          '<div class="jb-vipf__row">' +
            (st.pos > 0 ? '<button type="button" class="jb-vipf__link" data-vipf-undo>Zurück</button>' : '<button type="button" class="jb-vipf__link" data-vipf-back="pref">Fragen ändern</button>') +
            '<button type="button" class="jb-vipf__link" data-vipf-tolist>Fertig – zur Merkliste (' + likedCount() + ')</button>' +
          '</div>');
    }
    function viewList() {
      var ids = st.likeOrder.filter(function (id) { return st.likes[id]; });
      var head = '<h2 class="jb-vipf__h" id="jb-vipf-title">Deine Merkliste</h2>';
      var nMore = moreIds().length;
      var browse = st.pos < st.order.length
        ? '<button type="button" class="jb-vipf__link" data-vipf-browse>Weiter stöbern</button>'
        : nMore ? '<button type="button" class="jb-vipf__link" data-vipf-more>Weitere Sorten ansehen (' + nMore + ')</button>'
        : '<button type="button" class="jb-vipf__link" data-vipf-browse>Alle nochmal ansehen</button>';
      if (!ids.length) {
        return head + '<p class="jb-vipf__sub">Noch nichts gemerkt. Schau dir die Sorten an und tippe auf „Merken“.</p>' +
          '<div class="jb-vipf__stack">' +
            '<button type="button" class="jb-vipf__primary jb-vipf__primary--wide" data-vipf-' + (st.pos >= st.order.length && nMore ? 'more' : 'browse') + '>Sorten ansehen ' + ICON.arrow + '</button>' +
            '<button type="button" class="jb-vipf__link" data-vipf-restart>Quiz neu starten</button>' +
          '</div>';
      }
      var rows = ids.map(function (id) {
        var f = byId[id], q = st.likes[id];
        return '<li class="jb-vipf__item">' +
          (f.img ? '<img src="' + esc(f.img) + '" alt="" width="44" height="44" loading="lazy">' : '<span></span>') +
          '<div><p class="jb-vipf__item-name">' + esc(f.name) + '</p><p class="jb-vipf__item-line">' + lineLabel(f.line) + (isAvail(f) ? '' : ' · <span class="jb-vipf__out">ausverkauft</span>') + '</p></div>' +
          '<div class="jb-vipf__qty" role="group" aria-label="Menge ' + esc(f.name) + '">' +
            '<button type="button" data-vipf-dec="' + id + '" aria-label="Eine weniger"' + (q <= 1 ? ' disabled' : '') + '>' + ICON.minus + '</button>' +
            '<output aria-live="polite">' + q + '</output>' +
            '<button type="button" data-vipf-inc="' + id + '" aria-label="Eine mehr"' + (q >= QTY_MAX ? ' disabled' : '') + '>' + ICON.plus + '</button>' +
          '</div>' +
          '<button type="button" class="jb-vipf__rm" data-vipf-rm="' + id + '" aria-label="' + esc(f.name) + ' entfernen">' + ICON.trash + '</button>' +
        '</li>';
      }).join('');
      var n = boxes();
      var saved = !!readPicks();
      // the consent question (merchant 2026-10-09): nothing is kept without this Ja
      var foot = saved
        ? '<p class="jb-vipf__note">Gespeichert – Änderungen übernehmen wir automatisch.</p>' +
          '<button type="button" class="jb-vipf__primary jb-vipf__primary--wide" data-vipf-showsaved>Fertig ' + ICON.check18 + '</button>'
        : store
        ? '<p class="jb-vipf__ask">Sollen wir deine Sorten vorbereiten, damit du im Shop nur noch auf „In den Warenkorb“ drücken musst?</p>' +
          '<div class="jb-vipf__yesno">' +
            '<button type="button" class="jb-vipf__no" data-vipf-no>Nein, danke</button>' +
            '<button type="button" class="jb-vipf__primary" data-vipf-yes>Ja, bitte ' + ICON.check18 + '</button>' +
          '</div>'
        : '<p class="jb-vipf__warn">Speichern geht in diesem Browser leider nicht (privater Modus?). Merk dir einfach deine Sorten – sie stehen hier.</p>';
      return head +
        '<p class="jb-vipf__sub">' + (saved ? 'Passe die Menge an – genau das wartet später in deinem Sortenwähler.' : 'Passe die Menge an. Danach entscheidest du, ob wir sie für dich vorbereiten – ohne dein Ja speichern wir nichts.') + '</p>' +
        '<ul class="jb-vipf__list">' + rows + '</ul>' +
        '<p class="jb-vipf__note">1 Los pro Box · jede 6. Box ist gratis.</p>' +
        F('<p class="jb-vipf__total"><b>' + n + (n === 1 ? ' Box' : ' Boxen') + '</b> · ' + loseText(n) + '</p>' +
          foot +
          '<div class="jb-vipf__row">' + browse +
            '<button type="button" class="jb-vipf__link" data-vipf-restart>Quiz neu starten</button>' +
          '</div>');
    }
    function viewDeclined() {
      var rows = (declined || []).map(function (d) {
        var f = byId[d.id];
        return f ? '<li>' + esc(f.name) + ' <span>' + lineLabel(f.line) + ' · ' + d.q + '×</span></li>' : '';
      }).join('');
      var live = phase() === 'open' && gateLive();
      return '<h2 class="jb-vipf__h jb-vipf__center" id="jb-vipf-title">Alles klar – nichts gespeichert.</h2>' +
        '<p class="jb-vipf__sub jb-vipf__center">Deine Merkliste ist gelöscht.' + (rows ? ' Falls du sie dir notieren willst:' : '') + '</p>' +
        (rows ? '<ul class="jb-vipf__plain">' + rows + '</ul>' : '') +
        F((live ? '<button type="button" class="jb-vipf__primary jb-vipf__primary--wide" data-vipf-togate>Zum Tastenfeld ' + ICON.arrow + '</button>'
                : '<button type="button" class="jb-vipf__primary jb-vipf__primary--wide" data-vipf-close-done>Schließen</button>') +
          (rows && store ? '<div class="jb-vipf__row"><span></span><button type="button" class="jb-vipf__link" data-vipf-undecline>Doch vorbereiten</button></div>' : ''));
    }
    function viewSaved() {
      var p = readPicks();
      var n = picksCount(p);
      var rows = (p && p.items || []).map(function (i) {
        var f = byId[i.id];
        var img = f && f.img;
        return '<li class="jb-vipf__srow">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="44" height="44" loading="lazy" decoding="async">' : '<span class="jb-vipf__srow-ph"></span>') +
          '<div><p class="jb-vipf__srow-name">' + esc(f ? f.name : i.name) + '</p>' +
          '<p class="jb-vipf__srow-line">' + lineLabel(f ? f.line : i.line) + '</p></div>' +
          '<span class="jb-vipf__srow-qty">' + clampQty(i.qty) + '×</span>' +
        '</li>';
      }).join('');
      var live = gateLive();
      return '<div class="jb-vipf__done">' + ICON.check + '</div>' +
        '<h2 class="jb-vipf__h jb-vipf__center" id="jb-vipf-title">Deine Sorten sind vorbereitet!</h2>' +
        '<p class="jb-vipf__sub jb-vipf__center">Sobald du im Shop bist, ist deine Auswahl auf der Limited-Seite schon im Sortenwähler eingetragen – du musst nur noch „In den Warenkorb“ drücken.</p>' +
        '<ul class="jb-vipf__srows">' + rows + '</ul>' +
        '<p class="jb-vipf__sum"><b>' + n + (n === 1 ? ' Box' : ' Boxen') + '</b> · ' + loseText(n) + ' · auf diesem Gerät gespeichert</p>' +
        F((live ? '<button type="button" class="jb-vipf__primary jb-vipf__primary--wide" data-vipf-togate>Zum Tastenfeld ' + ICON.arrow + '</button>'
                : '<button type="button" class="jb-vipf__primary jb-vipf__primary--wide" data-vipf-close-done>Fertig</button>') +
          '<div class="jb-vipf__row"><button type="button" class="jb-vipf__link" data-vipf-edit>Auswahl ändern</button>' +
          '<button type="button" class="jb-vipf__link" data-vipf-clear>Auswahl löschen</button></div>');
    }

    /* ---------- the countdown bar in the finder: last minute before 10:00, and from 10:00 ---------- */
    function updateClock() {
      if (!clock) return;
      var ph = phase();
      var show = dlg.open && (ph === 'final' || ph === 'open');
      clock.hidden = !show;
      if (!show) return;
      var t = clock.querySelector('[data-vipf-clock-t]');
      var b = clock.querySelector('[data-vipf-abort]');
      var text = ph === 'final' ? 'Der Tresor öffnet in <b>' + untilLaunch(true) + '</b>' : '<b>Der Tresor ist offen!</b> Dein Code wartet.';
      if (t && t.innerHTML !== text) t.innerHTML = text;
      var label = unsaved() && store && st.step !== 'list' ? 'Quiz beenden' : 'Zum Tastenfeld';
      if (b && b.textContent !== label) b.textContent = label;
    }
    if (clock) clock.addEventListener('click', function (e) {
      if (!e.target.closest('[data-vipf-abort]')) return;
      // unsaved likes: first the Ja / Nein question, then straight on to the keypad
      if (unsaved() && store && st.step !== 'list') { leaving = true; st.step = 'list'; render(); return; }
      toGate();
    });

    /* ---------- actions ---------- */
    var animating = false; // a card is flying out — ignore further deck actions until the next card is there
    function decide(like) {
      animating = false;
      if (st.step !== 'deck' || st.pos >= st.order.length) return;
      var id = st.order[st.pos];
      var had = !!st.likes[id];
      // "Weiter" never removes something already on the Merkliste — removing happens there, visibly
      if (like && !had) { st.likes[id] = 1; st.likeOrder.push(id); }
      st.hist.push({ id: id, had: had });
      st.pos += 1;
      if (st.pos >= st.order.length) st.step = 'list';
      render();
    }
    function animateOut(like) {
      if (animating) return;
      var card = body.querySelector('[data-vipf-card]');
      if (!card) { decide(like); return; }
      animating = true;
      card.classList.remove('is-dragging');
      card.style.transform = '';
      card.classList.add(like ? 'is-out-right' : 'is-out-left');
      setTimeout(function () { decide(like); }, 190);
    }
    function undo() {
      var h = st.hist.pop();
      if (!h) return;
      st.pos = Math.max(0, st.pos - 1);
      var id = st.order[st.pos];
      // take back a like made by that decision (a like from before stays)
      if (!h.had && st.likes[id]) { delete st.likes[id]; st.likeOrder = st.likeOrder.filter(function (x) { return x !== id; }); }
      st.step = 'deck';
      render();
    }
    function bindSwipe() {
      var card = body.querySelector('[data-vipf-card]');
      if (!card || !window.PointerEvent) return;
      var likeStamp = card.querySelector('[data-vipf-stamp="like"]');
      var passStamp = card.querySelector('[data-vipf-stamp="pass"]');
      var x0 = null, y0 = 0, dx = 0, id = null, horizontal = null;
      card.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        x0 = e.clientX; y0 = e.clientY; dx = 0; id = e.pointerId; horizontal = null;
      });
      card.addEventListener('pointermove', function (e) {
        if (x0 === null || e.pointerId !== id) return;
        var mx = e.clientX - x0, my = e.clientY - y0;
        if (horizontal === null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) {
          horizontal = Math.abs(mx) > Math.abs(my);
          if (horizontal) { try { card.setPointerCapture(id); } catch (err) { /* ignore */ } card.classList.add('is-dragging'); }
        }
        if (!horizontal) return;
        dx = mx;
        card.style.transform = 'translateX(' + dx + 'px) rotate(' + (dx / 22) + 'deg)';
        var k = Math.min(1, Math.abs(dx) / SWIPE_AT);
        if (likeStamp) likeStamp.style.opacity = dx > 0 ? k : 0;
        if (passStamp) passStamp.style.opacity = dx < 0 ? k : 0;
      });
      function end(e) {
        if (x0 === null || (e && e.pointerId !== id)) return;
        x0 = null;
        if (horizontal && Math.abs(dx) >= SWIPE_AT) { animateOut(dx > 0); return; }
        card.classList.remove('is-dragging');
        card.style.transform = '';
        if (likeStamp) likeStamp.style.opacity = 0;
        if (passStamp) passStamp.style.opacity = 0;
      }
      card.addEventListener('pointerup', end);
      card.addEventListener('pointercancel', end);
    }
    function afterDecision() {
      if (leaving || phase() === 'open' && gateLive() && st.step !== 'saved') { leaving = false; toGate(); return true; }
      return false;
    }

    function onAction(e) {
      var t = e.target.closest('button');
      if (!t || !(body.contains(t) || (footer && footer.contains(t)))) return;
      if (animating) return;
      var a = function (n) { return t.getAttribute('data-vipf-' + n); };
      if (a('tab') !== null) {
        var i = a('tab'), open = t.getAttribute('aria-expanded') !== 'true';
        Array.prototype.forEach.call(body.querySelectorAll('[data-vipf-tab]'), function (b) { b.setAttribute('aria-expanded', b === t && open ? 'true' : 'false'); });
        Array.prototype.forEach.call(body.querySelectorAll('[data-vipf-panel]'), function (p) { p.hidden = !(open && p.getAttribute('data-vipf-panel') === i); });
        return;
      }
      if (a('line') !== null) { st.line = a('line'); st.cats = st.cats.filter(function (k) { return poolFor(st.line).some(function (f) { return f.cats.indexOf(k) >= 0; }); }); st.step = 'taste'; render(); return; }
      if (a('cat') !== null) {
        var k = a('cat'), ci = st.cats.indexOf(k);
        if (ci >= 0) st.cats.splice(ci, 1); else st.cats.push(k);
        t.setAttribute('aria-pressed', ci >= 0 ? 'false' : 'true');
        persist();
        return;
      }
      if (a('pref') !== null) { st.pref = a('pref'); startDeck(); return; }
      if (a('next') === 'taste') { st.step = 'pref'; render(); return; }
      if (a('skip') !== null) {
        var s = a('skip');
        if (s === 'line') { st.line = 'both'; st.step = 'taste'; }
        else if (s === 'taste') { st.cats = []; st.step = 'pref'; }
        else if (s === 'pref') { st.pref = 'any'; startDeck(); return; }
        render();
        return;
      }
      if (a('back') !== null) { st.step = a('back'); render(); return; }
      if (t.hasAttribute('data-vipf-like')) { animateOut(true); return; }
      if (t.hasAttribute('data-vipf-pass')) { animateOut(false); return; }
      if (t.hasAttribute('data-vipf-undo')) { undo(); return; }
      if (t.hasAttribute('data-vipf-tolist')) { st.step = 'list'; render(); return; }
      if (t.hasAttribute('data-vipf-browse')) {
        if (!st.order.length || st.pos >= st.order.length) { st.order = st.order.length ? st.order : buildOrder(); st.pos = 0; st.hist = []; }
        st.step = 'deck'; render(); return;
      }
      if (t.hasAttribute('data-vipf-more')) {
        var more = moreIds();
        if (!more.length) return;
        st.pos = st.order.length; st.order = st.order.concat(more); st.step = 'deck'; render(); return;
      }
      if (t.hasAttribute('data-vipf-restart')) { var keep = { likes: st.likes, likeOrder: st.likeOrder }; st = fresh(); st.likes = keep.likes; st.likeOrder = keep.likeOrder; render(); return; }
      if (a('inc') !== null) { var ii = a('inc'); st.likes[ii] = clampQty((st.likes[ii] || 0) + 1); render(); return; }
      if (a('dec') !== null) { var di = a('dec'); st.likes[di] = Math.max(1, (st.likes[di] || 1) - 1); render(); return; }
      if (a('rm') !== null) { var ri = a('rm'); delete st.likes[ri]; st.likeOrder = st.likeOrder.filter(function (x) { return x !== ri; }); render(); return; }
      if (t.hasAttribute('data-vipf-yes')) {
        if (writePicks()) { refreshEntry(); if (afterDecision()) return; st.step = 'saved'; render(); }
        else { body.insertAdjacentHTML('afterbegin', '<p class="jb-vipf__warn">Speichern hat nicht geklappt. Merk dir deine Sorten – sie stehen hier.</p>'); }
        return;
      }
      if (t.hasAttribute('data-vipf-no')) {
        // Nein: the Merkliste and the progress are deleted — only this view still lists them, until it is closed
        declined = st.likeOrder.filter(function (id) { return st.likes[id]; }).map(function (id) { return { id: id, q: st.likes[id] }; });
        drop(PICKS_KEY);
        wipe();
        refreshEntry();
        if (afterDecision()) { declined = null; return; }
        st.step = 'declined';
        render();
        return;
      }
      if (t.hasAttribute('data-vipf-undecline')) {
        (declined || []).forEach(function (d) { if (byId[d.id] && !st.likes[d.id]) { st.likes[d.id] = clampQty(d.q); st.likeOrder.push(d.id); } });
        declined = null;
        if (writePicks()) { st.step = 'saved'; refreshEntry(); } else st.step = 'list';
        render();
        return;
      }
      if (t.hasAttribute('data-vipf-edit')) { st.step = 'list'; render(); return; }
      if (t.hasAttribute('data-vipf-showsaved')) { st.step = readPicks() ? 'saved' : 'list'; render(); return; }
      if (t.hasAttribute('data-vipf-clear')) { drop(PICKS_KEY); st.likes = {}; st.likeOrder = []; st.step = 'list'; render(); refreshEntry(); return; }
      if (t.hasAttribute('data-vipf-togate')) { toGate(); return; }
      if (t.hasAttribute('data-vipf-close-done')) { close(); }
    }
    body.addEventListener('click', onAction);
    if (footer) footer.addEventListener('click', onAction);
    function startDeck() { st.order = buildOrder(); st.pos = 0; st.hist = []; st.step = 'deck'; render(); }

    /* ---------- open / close ---------- */
    function open() {
      closePop(false);
      leaving = false;
      if (pill) pill.hidden = true;
      if (st.step === 'saved' && !readPicks()) st.step = 'list';
      if (st.step === 'declined') st.step = 'line';
      document.documentElement.classList.add('jb-vipf-lock');
      try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
      render();
      body.scrollTop = 0; // a closed dialog keeps its old scroll position — always start at the top
      // focus the dialog box itself — Tab reaches the buttons; no ring around a button for mouse/touch users
      var box = dlg.querySelector('.jb-vipf__box');
      if (box) { box.setAttribute('tabindex', '-1'); try { box.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    }
    function close() {
      if (dlg.open) { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } }
      document.documentElement.classList.remove('jb-vipf-lock');
      if (st.step === 'declined') { declined = null; st.step = 'line'; }
      leaving = false;
      persist();
      refreshEntry();
    }
    dlg.addEventListener('close', function () { if (!(pop && pop.open)) document.documentElement.classList.remove('jb-vipf-lock'); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); }); // Esc
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { close(); return; } // backdrop
      if (e.target.closest('[data-vipf-close]')) { close(); }
    });
    // keys typed in the finder never reach the safe (assets/jb-vip.js listens on document)
    dlg.addEventListener('keydown', function (e) {
      e.stopPropagation();
      if (st.step !== 'deck' || e.metaKey || e.ctrlKey || e.altKey) return;
      if (e.target && e.target.closest && e.target.closest('[data-vipf-tab]')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); animateOut(true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); animateOut(false); }
    });

    /* ---------- the launch-day popup ---------- */
    // only before the last minute (merchant 2026-10-09: the countdown bar in the finder is enough for that minute)
    function viewPop() {
      var imgs = flavours.filter(function (f) { return isAvail(f) && f.img; }).slice(0, 3);
      var fan = imgs.length ? '<div class="jb-vipf-pop__fan" aria-hidden="true">' + imgs.map(function (f) {
        return '<img src="' + esc(f.img) + '" alt="" width="240" height="240" decoding="async">';
      }).join('') + '</div>' : '';
      return '<button type="button" class="jb-vipf-pop__x" data-vipf-pop-x aria-label="Hinweis schließen">' + ICON.close + '</button>' + fan +
        (now() < dayStart
          ? '<p class="jb-vipf-pop__kicker">Morgen ist Launch-Tag</p><h2 class="jb-vipf-pop__h" id="jb-vipf-pop-title">Morgen um 10:00 Uhr öffnet der Tresor</h2>'
          : '<p class="jb-vipf-pop__kicker">Heute ist Launch-Tag</p><h2 class="jb-vipf-pop__h" id="jb-vipf-pop-title">Um 10:00 Uhr öffnet der Tresor</h2>') +
        '<p class="jb-vipf-pop__cd" role="timer"><span>Noch</span> <b data-vipf-cd>' + untilLaunch(false) + '</b></p>' +
        '<p class="jb-vipf-pop__lead">Nutz die Wartezeit: Such dir jetzt deine Limited-Sorten aus – um 10:00 Uhr geht dann alles ganz schnell.</p>' +
        '<ol class="jb-vipf-pop__steps">' +
          '<li><b>Jetzt · 30 Sekunden</b><span>3 kurze Fragen, dann wischst du durch die passenden Sorten und merkst dir deine Favoriten.</span></li>' +
          '<li><b>Nur wenn du willst</b><span>Wir tragen deine Auswahl im Sortenwähler ein. Ohne dein Ja speichern wir nichts.</span></li>' +
          '<li><b>Ab 10:00 Uhr</b><span>Code ins Tastenfeld – im Shop drückst du dann nur noch „In den Warenkorb“.</span></li>' +
        '</ol>' +
        '<div class="jb-vipf-pop__ctas"><button type="button" class="jb-vipf__primary jb-vipf__primary--wide" data-vipf-pop-go>Sorten-Finder starten ' + ICON.arrow + '</button>' +
          '<button type="button" class="jb-vipf__link" data-vipf-pop-x>Nein danke, ich warte auf 10:00 Uhr</button></div>';
    }
    function closePop(dismiss) {
      if (!pop || !pop.open) return;
      if (dismiss) save(POP_KEY, now());
      try { pop.close(); } catch (e) { pop.removeAttribute('open'); }
      if (!dlg.open) document.documentElement.classList.remove('jb-vipf-lock');
      refreshEntry();
    }
    function popDismissed() { var t = load(POP_KEY); return typeof t === 'number' && t >= activeFrom && t < dayEnd && t <= now(); }
    function tryPop() {
      if (!pop || pop.open || dlg.open) return;
      if (phase() !== 'wait') return; // never in the last minute or after 10:00 — then the keypad comes first
      if (popDismissed() || readPicks() || gateBusy() || likedCount() || st.step !== 'line') return;
      if (gateEl() && gateEl().classList.contains('is-error')) return; // a wrong code re-rendered the page
      if (document.hidden) { document.addEventListener('visibilitychange', function once() { if (!document.hidden) { document.removeEventListener('visibilitychange', once); setTimeout(tryPop, 1500); } }); return; }
      if (pill) pill.hidden = true;
      popBox.innerHTML = viewPop();
      document.documentElement.classList.add('jb-vipf-lock');
      try { pop.showModal(); } catch (e) { pop.setAttribute('open', ''); }
      // focus the card itself (Tab reaches the buttons) — no focus ring around a button for mouse/touch users
      popBox.setAttribute('tabindex', '-1');
      try { popBox.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
    if (pop) {
      pop.addEventListener('keydown', function (e) { e.stopPropagation(); }); // Enter on its buttons ≠ submit the safe
      pop.addEventListener('cancel', function (e) { e.preventDefault(); closePop(true); });
      pop.addEventListener('click', function (e) {
        if (e.target === pop || e.target.closest('[data-vipf-pop-x]')) { closePop(true); return; }
        if (e.target.closest('[data-vipf-pop-go]')) { closePop(true); open(); }
      });
    }

    /* ---------- entry points ---------- */
    function refreshEntry() {
      var p = readPicks();
      var on = phase() !== 'off';
      Array.prototype.forEach.call(document.querySelectorAll('[data-vipf-entry]'), function (el) { el.hidden = !on; });
      Array.prototype.forEach.call(document.querySelectorAll('[data-vipf-entry-text]'), function (el) {
        el.innerHTML = p
          ? '<b>Deine Sorten sind vorbereitet:</b> ' + picksCount(p) + (picksCount(p) === 1 ? ' Box' : ' Boxen') + ' – sie warten im Sortenwähler auf der Limited-Seite.'
          : 'Unsicher, welche Sorten? <b>Der Sorten-Finder</b> hilft dir in 30 Sekunden.';
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-vipf-entry-btn]'), function (el) {
        el.textContent = p ? 'Auswahl ansehen' : 'Sorten-Finder starten';
      });
      updatePill();
    }

    /* ---------- pill for customers who said Ja, tucked away while the live keypad is in view ---------- */
    var pill = document.querySelector('[data-vipf-pill]');
    if (pill) document.body.appendChild(pill);
    var tucked = false;
    var PILL_X = 'jbVipFinderPillX';
    function pillDismissed() { try { return !!window.sessionStorage.getItem(PILL_X); } catch (e) { return false; } }
    function updatePill() {
      if (!pill) return;
      var p = readPicks();
      var show = !!p && phase() !== 'off' && !dlg.open && !(pop && pop.open) && !tucked && !pillDismissed();
      if (show) {
        var n = picksCount(p);
        var el = pill.querySelector('[data-vipf-pill-n]');
        if (el) el.textContent = n + (n === 1 ? ' Box' : ' Boxen');
      }
      pill.hidden = !show;
    }
    if (pill) {
      pill.addEventListener('keydown', function (e) { e.stopPropagation(); }); // Enter on its buttons ≠ submit the safe
      var px = pill.querySelector('[data-vipf-pill-x]');
      if (px) px.addEventListener('click', function () { try { window.sessionStorage.setItem(PILL_X, '1'); } catch (e) { /* ignore */ } pill.hidden = true; });
    }
    (function watchKeypad() {
      var g = gateEl();
      if (!g || !window.IntersectionObserver) return;
      new IntersectionObserver(function (entries) {
        tucked = entries.some(function (en) { return en.isIntersecting; }) && gateLive();
        updatePill();
      }).observe(g);
    })();
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-vipf-open]');
      if (!t || phase() === 'off') return;
      e.preventDefault();
      if (readPicks()) st.step = t.getAttribute('data-vipf-open') === 'list' ? 'list' : 'saved';
      open();
    });
    // typing into the safe: no popup, no pill
    document.addEventListener('input', function (e) { if (e.target && e.target.matches && e.target.matches('[data-jb-vip-code]') && pill) pill.hidden = true; });

    /* ---------- one clock for everything: the day window, the popup, the countdown bar ---------- */
    var delay = Math.max(10, Math.min(180, Number(cfg.delay) || 60)) * 1000;
    var popTimer = null, lastPhase = null;
    function tick() {
      var ph = phase();
      if (ph !== lastPhase) {
        lastPhase = ph;
        refreshEntry();
        if (ph === 'wait' && !popTimer) popTimer = setTimeout(tryPop, delay);
        // at 09:59 an open popup goes away by itself (not counted as "Nein danke")
        if (ph !== 'wait' && pop && pop.open) closePop(false);
      }
      if (pop && pop.open) {
        var cd = popBox.querySelector('[data-vipf-cd]');
        var v = untilLaunch(false);
        if (cd && cd.textContent !== v) cd.textContent = v;
      }
      updateClock();
    }
    tick();
    setInterval(tick, 1000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
